import {Injectable} from '@angular/core';
import {Effect, Actions} from '@ngrx/effects';
import {AuthService} from '../../auth.service';
import * as authAction from '../actions/auth.actions';
import * as configAction from '../actions/config.action';
import {map, mergeMap} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {Action} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import {AccountType} from '../../users/account-type';
import {UserService} from '../../shared/user.service';


@Injectable()
export class AuthEffect {
  constructor(private actions: Actions, private auth: AuthService, private userService: UserService) {
  }

@Effect()
loginUser: Observable<Action> = this.actions.ofType(authAction.LOGIN_USER)
  .map((action: authAction.LoginUser) => action.payload)
  .pipe(
    mergeMap((user) => {
      return this.auth.signIn(user).map(_user => {
        if (_user.accountType === AccountType.POPUP) {
          if (_user.popupStores.length === 0) {
            this.auth.signOut();
            return new authAction.LoginUserFail('No Stores assigned to your account. Please contact store.');
          }
          return new authAction.LoginUserSuccess(_user);
        } else {
          this.auth.signOut();
          return new authAction.LoginUserFail('Access denied');
        }
      }).catch(error => of(new authAction.LoginUserFail('Invalid Login Credentials')));
    }));

  @Effect()
  loggedInUserData: Observable<Action> = this.actions.ofType(authAction.LOAD_USER)
    .pipe(
      mergeMap(() => {
        return this.userService.getUserData(this.auth.currentUser.getValue().id)
          .map(r => new authAction.LoadUserSuccess(r))
          .catch(e => of(new authAction.LogoutUser()));
      })
    );

  @Effect({dispatch: false})
  logoutUser: Observable<Action> = this.actions.ofType(authAction.LOGOUT_USER)
    .map(() => {
      this.auth.signOut();
      return new authAction.LogoutUser();
    });

  @Effect()
  loadAppConfig: Observable<Action> = this.actions.ofType(configAction.GET_CONFIG)
    .pipe(
      mergeMap(() => {
        return this.auth.appConfig()
          .map(r => new configAction.GetConfigSuccess(r))
          .catch(e => of(new configAction.GetConfigFail(e)));
      })
    );


}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/store/effects/auth.effect.ts